import React, { useState } from 'react';
import { useEffect } from 'react';
import {
    Modal,
    Box,
    Typography,
    TextField,
    Button
} from '@mui/material';
import { showToast, showDangerToast } from '../../constants/toaster';
import ApiCaller from '../../constants/ApiCaller';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
};

const AddGradeModal = ({ open, onClose, onSuccess, token, updatedBy, editData }) => {

    const endpoint = editData ? '/api/admin-service/grades/update' : '/api/admin-service/grades/add';
    const [formData, setFormData] = useState({
        gradeName: '',
        gradeValue: '',
    });

    useEffect(() => {

        console.log("updatedById", editData);
        if (editData) {
            setFormData({
                id: editData.id || '',
                gradeName: editData.gradeName || '',
                gradeImage: editData.gradeImage || '',
                 gradeValue: editData.gradeValue || '',
                updatedBy: editData.updatedBy || '',
                oldGradeName: editData.gradeName || '',
                uuid: editData.uuid || ''
            });

        } else {
            setFormData({
                gradeName: '',
                gradeValue: '',
                gradeImage: '',
                updatedBy: updatedBy || '',
            });
        }
    }, [editData, updatedBy]);


    const [gradeImageFile, setGradeImageFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState('');

    const handleInputChange = e => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleImageChange = e => {
        const file = e.target.files[0];
        if (file) {
            setGradeImageFile(file);
            setPreviewUrl(URL.createObjectURL(file));
        }
    };

    //   const handleSubmit = async () => {
    //     const { gradeName, gradeValue } = formData;

    //     if (!gradeName || !gradeValue || !updatedBy) {
    //       showDangerToast('Please fill all required fields');
    //       return;
    //     }

    //     const form = new FormData();
    //     form.append('gradeName', gradeName);
    //     form.append('gradeValue', gradeValue);
    //     form.append('updatedBy', updatedBy);
    //     if (gradeImageFile) {
    //       form.append('gradeImage', gradeImageFile);
    //     }

    //     try {
    //       const res = await fetch('/api/user-service/grades/add', {
    //         method: 'POST',
    //         headers: {
    //           Authorization: `Bearer ${token}`,
    //         },
    //         body: form
    //       });

    //       const response = await res.json();

    //       if (response.status === '200' || response.status === 200) {
    //         showToast(response.message || 'Grade added successfully');
    //         onSuccess && onSuccess();
    //         onClose();
    //         setFormData({ gradeName: '', gradeValue: '' });
    //         setGradeImageFile(null);
    //         setPreviewUrl('');
    //       } else {
    //         showDangerToast(response.message || 'Failed to add grade');
    //       }
    //     } catch (err) {
    //       console.error(err);
    //       showDangerToast('Error while submitting grade');
    //     }
    //   };


    const handleSubmit = async () => {
        const { gradeName, gradeValue, updatedBy, gradeImage, uuid } = formData;

        if (!gradeName || !gradeValue || !updatedBy) {
            showDangerToast('Please fill all required fields');
            return;
        }

        // const endpoint = uuid
        //     ? '/api/user-service/grades/update'  // You need to implement this
        //     : '/api/admin-service/grades/add';



        try {
            const res = await ApiCaller.post(
                formData,
                endpoint,
                token
            );
            const response = await res.response.json();

            if (response.status === "200") {
                showToast(response.message || 'Grade saved successfully');
                onSuccess && onSuccess();
                onClose();
            } else {
                showDangerToast(response.message || 'Failed to save grade');
            }
        } catch (err) {
            console.error(err);
            showDangerToast('Error while submitting grade');
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                <Typography variant="h6" mb={2}>Add New Grade</Typography>

                <TextField
                    fullWidth
                    label="Grade Name"
                    name="gradeName"
                    value={formData.gradeName}
                    onChange={handleInputChange}
                    margin="normal"
                    required
                />

                <TextField
                    fullWidth
                    label="Grade Value"
                    name="gradeValue"
                    type="number"
                    value={formData.gradeValue}
                    onChange={handleInputChange}
                    margin="normal"
                    required
                />

                <Box mt={2}>
                    <input
                        accept="image/*"
                        type="file"
                        onChange={handleImageChange}
                    />
                    {previewUrl && (
                        <img
                            src={previewUrl}
                            alt="Preview"
                            style={{ marginTop: 10, maxWidth: '150px', height: '150px' }}
                        />
                    )}
                </Box>

                {/* <TextField
                    fullWidth
                    label="Updated By"
                    name="updatedBy"
                    value={updatedBy}
                    margin="normal"
                    disabled
                /> */}

                <Box mt={3} display="flex" justifyContent="space-between">
                    <Button variant="outlined" onClick={onClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleSubmit} color="primary">
                        Submit
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default AddGradeModal;
